// extracted by mini-css-extract-plugin
module.exports = {"Container":"NewsPost_Container__3CTuN","MobileContainer":"NewsPost_MobileContainer__iTtYf"};